<template>
  <div>
    <el-dialog
      title="历史版本查看"
      v-model="visible"
      :close-on-click-modal="false"
      width="760px"
      :visible.sync="visible"
       :before-close="handleClose"
    >
      <el-form :model="viewForm" class="toolbar" ref="viewForm" label-width="80px">
        <el-row type="flex" justify="center" >
          <el-col :span="9">
            <el-form-item label="选品单号">
              <el-input v-model="viewForm.sipCode" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="15">
            <!-- <el-form-item label="棚格图分类">
              <el-input v-model="viewForm.sipSpaceCode" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="棚格图分类" prop="sipSpaceCode">
              <el-select
                v-model="sipSpaceCode"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,i) in List"
                  :key="i"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between" >
          <el-col :span="9">
            <el-form-item label="版本">
              <el-select v-model="viewForm.version" filterable placeholder="请选择">
                <el-option
                  v-for="(item,i) in versionList"
                  :key="i"
                  :label="'V' + item"
                  :value="item + ''"
                >                 
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="13" style="display:flex">
            <el-form-item label="选版">
              <el-select v-model="viewForm.sipSpaceMode" placeholder="请选择" disabled>
                <el-option label="T版" value="1"></el-option>
                <el-option label="S版" value="2"></el-option>
                <el-option label="M版" value="3"></el-option>
                <el-option label="L版" value="4"></el-option>
                <el-option label="XL版" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="sipUpperId">
              <el-input v-model="viewForm.sipUpperId" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item style="text-align: right;" class="leftNolabel">
              <el-button type="primary" @click="handelExport()">导出</el-button>
            </el-form-item> 
          </el-col>  
        </el-row>
      </el-form>
       <!-- 列表 -->
      <el-table
        :data="ruleItemList"
        class="listTowline"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%;"
      >
        <el-table-column prop="sitOrder" label="优先级" min-width="80"></el-table-column>
        <el-table-column prop="sirRuleName" label="规则名称" min-width="80"></el-table-column>
        <el-table-column label="详情" min-width="80">
          <template slot-scope="scope">
            <el-button type="primary" style="padding:5px;" @click.stop="handleLook(scope.row)" v-if="!(scope.row.sitRuleCode=='5' || scope.row.sitRuleCode=='6')">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dalog-footer">
        <el-button @click.native="handleClose()">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 查看货架sku选品数量 -->
    <SkuDetail  v-if="skuVisible" :visible.sync="skuVisible" :params="params" :pogList="List"></SkuDetail>
    <!-- 查看细分类必选 -->
    <SsubDetail  v-if="ssubVisible" :visible.sync="ssubVisible" :params="params" :pogList="List"></SsubDetail>
    <!-- 查看淘汰单品不选 -->
    <WeedOutDetail  v-if="weedOutVisible" :visible.sync="weedOutVisible" :params="params" :pogList="List"></WeedOutDetail>
    <!-- 查看免死单品必选 -->
    <EssentialDetail  v-if="essentialVisible" :visible.sync="essentialVisible" :params="params" :pogList="List"></EssentialDetail>
    <!-- 查看权重 -->
    <WeightSetCheckDetail  v-if="weightSetCheckVisible" :visible.sync="weightSetCheckVisible" :viewFormDetail="weightForm" :pogList="List"></WeightSetCheckDetail>
  </div>
</template>
<script>
import SkuDetail from "./lookHistory/skuDetail";
import SsubDetail from "./lookHistory/ssubDetail";
import WeedOutDetail from "./lookHistory/weedOutDetail";
import EssentialDetail from "./lookHistory/essentialDetail";
import WeightSetCheckDetail from "./look/weightSetCheckDetail";
export default{
 props: {
    visible: {
      type: Boolean,
      default: false
    },
    viewForm: {
      type: Object,
      default() {
          return {}
      }
    },
    sipId: {
      type: String,
      default:""
    },
    versionList : {
      type : Array,
      default: function () {return []}
    }
  },
  data: function() {
    return {
      ruleItemList : [],
      List: [],
      skuVisible : false,
      ssubVisible : false,
      weedOutVisible : false,
      essentialVisible : false,
      weightSetCheckVisible : false,
      weightForm: {},
      params : {},
      mrId: "",
      sipSpaceCode:''
    };
  },
  components : {
    SkuDetail,
    SsubDetail,
    WeedOutDetail,
    EssentialDetail,
    WeightSetCheckDetail
  },
  methods : {
    changePgt(val){
      console.log(val);
    },
    handleClose(){
      this.$emit('update:visible', false);
    },
    getMrId() {
      var _this = this;
      let para = {"sipId":this.sipId};
      _this.$api.selectgoods.getRulealterAppBysipId(para).then(res => {
        _this.mrId = res.data.object.mrId;
      });
    },
    handelExport(){
      var _this = this;
      let para = { 
        "sipId" : _this.sipId,
        "sipCode" : _this.viewForm.sipCode,
        "sisVersion" : _this.viewForm.version
      };
      this.$api.selectgoods.exportExcel(para).then(res => {
        var blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        var filename = res.headers["content-disposition"].split(";")[1].split("=")[1];
        downloadElement.download = window.decodeURI(filename); //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        // this.$emit('update:visible', false);
        // this.$emit("refreshQuery");
      })
      .catch(err =>
        this.$message({
          type: "error",
          message: err
        })
      );
    },
    getRuleItemList() {
      var _this = this;
      let para = {};
      this.listLoading = true;
      this.$api.selectgoods.getRuleItemListDetail(para).then(res => {
        this.ruleItemList = res.data.result;
        this.listLoading = false;
      });
    },
    handleLook(row){
      switch(row.sitRuleCode){
        case "1" : this.skuClick();         //货架sku选品数量
                break;
        case "2" : this.ssubClick();         //细分类必选
                break;
        case "3" : this.weedOutClick();         //淘汰单品不选
                break;
        case "4" : this.essentialClick();         //免死单品必选
                break;
        case "7" : this.weightSetCheckClick();         //按权重得分从高到低
                break;
        default :
                break;
      }
    },
    skuClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.sipSpaceCode;
      this.params.mrId = this.mrId;
      this.params.sipId = this.sipId;
      this.params.isvVersion = this.viewForm.version;
      this.params.sqvSpeccode = this.viewForm.sipSpaceMode;
      this.skuVisible = true;
    },
    ssubClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.sipSpaceCode;
      this.params.mrId = this.mrId;
      this.params.sipId = this.sipId;
       this.params.isvVersion = this.viewForm.version;
      this.ssubVisible = true;
    },
    weedOutClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.sipSpaceCode;
      this.params.sipId = this.sipId;
       this.params.isvVersion = this.viewForm.version;
      this.weedOutVisible = true;
    },
    essentialClick() {
      this.params.dept = this.viewForm.sipItemDept;
      this.params.spaceclassNew = this.sipSpaceCode;
      this.params.sipId = this.sipId;
       this.params.isvVersion = this.viewForm.version;
      this.essentialVisible = true;
    },
    weightSetCheckClick(){
      // this.listLoading = true;
      this.weightForm.dept = this.viewForm.sipItemDept;
      this.weightForm.spaceclassNew = this.sipSpaceCode;
      this.weightForm.sipMode = this.viewForm.sipMode;
      this.weightForm.sipIndication = this.viewForm.sipIndication;
      this.weightForm.mrId = this.mrId;
      this.weightForm.sipId = this.viewForm.sipId;
      this.weightForm.wijVersion = this.viewForm.version;
      this.weightSetCheckVisible = true;      
    },
  },
  created(){
    this.List = this.viewForm.sipSpaceCode.split(",");
    this.viewForm.sipSpaceCode = this.List[0];
    this.sipSpaceCode = this.List[0];
    this.$set(this.viewForm,'version',this.versionList[0]);
    this.getRuleItemList();
    // this.getMrId();
  }
} 
</script>


// WEBPACK FOOTER //
// src/views/selectgoods/selectionmanagement/listquery/historyVersionDialog.vue